import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/dingwei.png'


const _withScopeId = n => (_pushScopeId("data-v-00fbb924"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-amap-location" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dingwei",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = ["onClick"]

import {
  inject, markRaw, ref, getCurrentInstance, ComponentInternalInstance,
} from 'vue'
import { EventEmitter } from 'events'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-amap-location',
  props: {
  location: {
    type: Array,
    default: undefined,
  },
  address: {
    type: String,
    default: '',
  },
},
  setup(__props, { expose }) {

const props = __props


const instance = getCurrentInstance() as ComponentInternalInstance
const searchText = ref<string>('')
const searchData = ref<Array<any>>([])
const centerPos = ref(['104.06772126171873', '30.65261799182872'])

const emitter = inject<EventEmitter>('$map-emitter')

const getLocation = () => {
  const geocoder = new AMap.Geocoder()
  geocoder.getAddress(centerPos.value, (status:any, result:any) => {
    if (status === 'complete' && result.regeocode) {
      const address = result.regeocode.formattedAddress
      searchText.value = address
    } else {
      console.log('根据经纬度查询地址失败')
    }
  })
}

let amap:any
emitter?.once('init', (_map) => {
  amap = markRaw(_map)
  if (props.location) {
    centerPos.value = props.location as Array<string>
    amap.setCenter(centerPos.value)
  }
  amap.on('moveend', (e:any) => {
    const center = amap.getCenter()
    centerPos.value = [center.lng, center.lat]
    getLocation()
  })
})

const onChangeSearch = async () => {
  const autoComplete = new AMap.Autocomplete()
  autoComplete.search(searchText.value, (status:any, result:any) => {
    // amap.setCenter(centerPos.value)
    if (status !== 'complete') {
      // instance.proxy?.$message.error('')
      searchData.value = []
      return
    }
    searchData.value = result.tips
  })
}

const searchItem = (item:any) => {
  const placeSearch = new AMap.PlaceSearch({
    map: amap,
  }) // 构造地点查询类
  placeSearch.setCity(item.adcode)
  placeSearch.search(item.name) // 关键字查询查询
  searchData.value = []
}

expose({
  searchText,
  centerPos,
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_input, {
      class: "search-input",
      modelValue: searchText.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
      placeholder: "",
      onInput: onChangeSearch,
      clearable: "",
      "prefix-icon": "Search"
    }, null, 8, ["modelValue"]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchData.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id,
          onClick: ($event: any) => (searchItem(item))
        }, _toDisplayString(item.name), 9, _hoisted_4))
      }), 128))
    ], 512), [
      [_vShow, searchData.value && searchData.value.length>0]
    ])
  ]))
}
}

})